module.exports = __webpack_public_path__ + "img/switzerland-respiratory-diseases-female.f8592537.png";